<!-- 确认费用并取消弹框 -->
<template>
    <el-dialog width="30%" center append-to-body title="取消订单" :visible.sync="outerVisible">
        <div class="outer-dialog" v-if="JSON.stringify(datas) !== '{}'">
<!--            <div class="outer-dialog-top"-->
<!--                v-for="(item, index) in datas.modifyOrderCancelDetailResultList.filter((obj, ins) => datas.modifyOrderCancelDetailResultList.findIndex((item1) => item1.cancellationPolicyDescription === obj.cancellationPolicyDescription) === ins)">-->
<!--                <span v-html="item.cancellationPolicyDescription"></span>-->
<!--            </div>-->
<!--            <el-divider></el-divider>-->
            <div class="outer-dialog-center">
                <div class="outer-dialog-center-line">
                    <div class="outer-dialog-center-line-left">
                        预付金额:
                    </div>
                    <div class="outer-dialog-center-line-right">
                        <p class="outer-dialog-center-line-right-text">
                            ￥{{ totalPrice }}元
                        </p>
                        <div class="outer-dialog-center-line-right-text-box">
                            <p class="outer-dialog-center-line-right-text-box-line">
                                <span>商品金额:</span>
                                <span>￥{{ totalPrice }}元</span>
                            </p>
                            <p class="outer-dialog-center-line-right-text-box-line">
                                <span>满100减10:</span>
                                <span>-￥0元</span>
                            </p>
                            <p class="outer-dialog-center-line-right-text-box-line">
                                <span>360钻石会员优惠:</span>
                                <span>-￥0元</span>
                            </p>
                            <p class="outer-dialog-center-line-right-text-box-line">
                                <span>供应商用户:</span>
                                <span>-￥0元</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="outer-dialog-center-line">
                    <div class="outer-dialog-center-line-left">
                        原取消费用:
                    </div>
                    <div class="outer-dialog-center-line-right">
                        <p class="outer-dialog-center-line-right-text">
                            <span class="outer-dialog-center-line-right-text1">
                                按照商品的取消政策
                            </span>
                            -￥{{ datas.cancelTotalPrice }}元
                        </p>
                    </div>
                </div>
                <div v-if="datas.orderChildrenCancel && datas.orderChildrenCancel.merchantCancelPrice" class="outer-dialog-center-line">
                    <div class="outer-dialog-center-line-left">
                        沟通后的取消费用:
                    </div>
                    <div class="outer-dialog-center-line-right">
                        <p class="outer-dialog-center-line-right-text">
                            <span class="outer-dialog-center-line-right-text1">
                                按照商家提供的取消费用
                            </span>
                            -￥{{ datas.orderChildrenCancel.merchantCancelPrice }}元
                        </p>
                    </div>
                </div>
                <div class="outer-dialog-center-line">
                    <div class="outer-dialog-center-line-left">
                        退款金额:
                    </div>
                    <div class="outer-dialog-center-line-right">
                        <p class="outer-dialog-center-line-right-text">
                            <span class="outer-dialog-center-line-right-text1">
                                预计七个工作日内退款
                            </span>
                            ￥{{refundAmount.toFixed(2) }}元
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="isShowFooterBtn" class="outer-dialog-footer">
                <div class="outer-dialog-footer-top">
                    <div class="outer-dialog-footer-yuan">
                        ?
                    </div>
                    <p>取消原因</p>
                </div>
                <div class="outer-dialog-footer-center">
                    <div :class="item.code === communicationCancellation.cancelReasonType ? 'active' : ''"
                        class="outer-dialog-footer-center-box" @click="selectReason(item.code)"
                        v-for="( item, index ) in  testArr " :key="index">
                        {{ item.name }}
                    </div>
                </div>
                <el-input v-if="communicationCancellation.cancelReasonType === 3" size="small"
                    v-model="communicationCancellation.otherReason" placeholder="其它原因"></el-input>
            </div>
<!--            <div v-if="this.datas.orderChildrenCancel" class="merchantResponse">-->
<!--                商户提供的取消费用为:-->
<!--                <p> {{ merchantStatusTips }}</p>-->
<!--            </div>-->
        </div>
        <el-dialog width="22%" center :visible.sync="innerVisible" append-to-body>
            <div class="inner-dialog">
                <div class="inner-dialog-top">
                    <span>*</span> 说明：
                </div>
                <div class="inner-dialog-tip">
                    <p>平台仅为您提供与供应商沟通取消费用的</p>
                    <p>服务，最终取消费用以供应商的回复为准，供应商</p>
                    <p>回复的取消费用将小于或等于应收取的取消费用。</p>
                    <p>请在供应商回复后尽快点击确认费用并取消订单,</p>
                    <p>否则视为您无要维续保留订单。</p>
                    <p>请在此处填写您希望的取消费用为：</p>
                </div>
                <el-input @input="(value) => {
                    isNaN(value) ? isNaN(parseFloat(value)) ?
                        communicationCancellation.hopeCanelPrice = null : communicationCancellation.hopeCanelPrice = parseFloat(value) : communicationCancellation.hopeCanelPrice = value
                }" style="padding-left: 0.12rem;" v-model="communicationCancellation.hopeCanelPrice"
                    placeholder="只能输入数字！"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="cancelClick1">确认发送</el-button>
                <el-button size="small" plain @click="innerVisible = false">取消发送</el-button>
            </div>
        </el-dialog>
        <div v-if="isShowFooterBtn" slot="footer" class="dialog-footer">
            <el-button size="small" style="color: #D5562E;margin-bottom: 0.1rem;" plain
                @click="cancelClick">确认费用并取消订单</el-button>
            <!-- <p @click="merchantCommunicationClick"
                v-if="!this.datas.orderChildrenCancel && totalPrice != datas.refundableTotalAmount"
                style="color: #A7A9A7;cursor: pointer;">与商家沟通取消费用</p> -->
                <p @click="merchantCommunicationClick" style="color: #A7A9A7;cursor: pointer;">与商家沟通取消费用</p>
        </div>
    </el-dialog>
</template>

<script>
import OrderApi from "@/components/Api/order";
export default {
    components: {},
    data() {
        return {
            isShowFooterBtn:true,
            outerVisible: false,
            innerVisible: false,
            datas: {},
            price: null,
            communicationCancellation: {
                orderChildrenId: null,
                cancelReasonType: null,
                otherReason: '',
                hopeCanelPrice: null,

            },
            merchantStatusTips: '',
            testArr: [
                {
                    name: '行程取消',
                    code: 0
                },
                {
                    name: '信息填错',
                    code: 1
                },
                {
                    name: '换个产品',
                    code: 2
                },
                {
                    name: '其它',
                    code: 3
                }
            ]
        }
    },
    computed: {
        totalPrice() {
            let price = 0
            if (JSON.stringify(this.datas) !== '{}' && this.datas) {
                this.datas.modifyOrderCancelDetailResultList.forEach(item => {
                    price += item.amountPaid
                })
            }
            return price.toFixed(2)
        },
        //退款金额
        refundAmount() {
            return  this.totalPrice - this.communicationCosts
        },
        //取消费用
        communicationCosts() {
            return this.datas.orderChildrenCancel ? this.datas.orderChildrenCancel.merchantCancelPrice : this.datas.cancelTotalPrice
        }
    },
    watch: {},
    methods: {
        merchantCommunicationClick() {
            if (this.communicationCancellation.cancelReasonType !== null && this.communicationCancellation.cancelReasonType !== 3) {
                this.innerVisible = true
            } else if (this.communicationCancellation.cancelReasonType && this.communicationCancellation.cancelReasonType === 3) {
                if (this.communicationCancellation.otherReason) {
                    this.innerVisible = true
                } else {
                    this.$message({
                        message: '请输入其它原因',
                        type: 'warning'
                    });
                }
            } else {
                this.$message({
                    message: '请选择取消原因',
                    type: 'warning'
                });
            }

        },
        selectReason(code) {
            this.communicationCancellation.cancelReasonType = code
        },
        initClick(orderChildrenId,isShowFooterBtn = true) {
            this.isShowFooterBtn = isShowFooterBtn
            this.communicationCancellation = {
                orderChildrenId: null,
                cancelReasonType: null,
                otherReason: '',
                hopeCanelPrice: null,
            }
            this.communicationCancellation.orderChildrenId = orderChildrenId
            this.orderChildrenId = orderChildrenId
            let obj = {
                orderChildrenId,
            }
            new OrderApi('order').paidModifyOrderCancel(obj).then(res => {
                if (res.status == 200) {
                    this.datas = res.data
                    if (this.datas.orderChildrenCancel) {
                        this.communicationCancellation.cancelReasonType = this.datas.orderChildrenCancel.cancelReasonType
                        const map = {
                            0: '按照商品的取消政策',
                            1: '无损取消',
                            2: '全损取消',
                            3: '按照如下的取消金额收取取消费用为：' + this.datas.orderChildrenCancel.merchantCancelPrice + '¥'
                        }
                        this.merchantStatusTips = map[this.datas.orderChildrenCancel.merchantStatus]
                    }
                    this.outerVisible = true
                    console.log(this.datas, '坎坎坷坷看看');
                } else {
                    this.$message({
                        type: 'warning',
                        message: res.statusText
                    });
                }
            })
        },
        //订单取消
        cancelClick() {
            const messageHtml = `<div>您确定取消订单吗? 取消费用为<span style="color:#f56c6c;font-weight:bold;">${this.communicationCosts}¥</span> 可退款金额为:<span style="color:#f56c6c;font-weight:bold;">${this.refundAmount}¥</span></div>`
            this.$confirm(messageHtml, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                // new OrderApi('order').orderHasBeenPaidAndCancelled(this.orderChildrenId).then(res => {
                //     if (res.status == 200) {
                //         this.$message({
                //             type: 'success',
                //             message: '取消成功!'
                //         });
                //         this.outerVisible = false
                //     } else {
                //         this.$message({
                //             type: 'warning',
                //             message: res.statusText
                //         });
                //     }
                // })
                new OrderApi('order').orderPartHasBeenPaidAndCancelled1(this.orderChildrenId).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: '取消成功!'
                        });
                        this.$emit('updateList')
                        this.outerVisible = false
                    } else {
                        this.$message({type:"error",message:res.statusText})
                    }
                })
            })
        },
        cancelClick1() {
            if (this.communicationCancellation.hopeCanelPrice) {
                const messageHtml = `<div>您确定发送吗? 您希望的取消费用为<span style="color:#f56c6c;font-weight:bold;">${this.communicationCancellation.hopeCanelPrice}¥</span>，可退款金额为:<span style="color:#f56c6c;font-weight:bold;">${this.refundAmount}¥</span></div>`
                this.$confirm(messageHtml, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    new OrderApi('order').merchantCommunication(this.communicationCancellation).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: '发送成功!'
                            });
                            this.innerVisible = false
                            this.outerVisible = false
                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.statusText
                            });
                        }
                    })

                })
            } else {
                this.$message({
                    message: '请输入金额！',
                    type: 'warning'
                });
            }
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.active {
    background-color: #CE5F3A;
    color: #fff;
}

.outer-dialog {
    padding: 0 0.4rem;

    .outer-dialog-top {
        color: #000;

        .outer-dialog-top-text-bold {
            font-weight: bold;
            color: #000;
        }
    }

    .outer-dialog-center {
        .outer-dialog-center-line {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.12rem;

            .outer-dialog-center-line-left {
                font-weight: bold;
                color: #000;
            }

            .outer-dialog-center-line-right {
                .outer-dialog-center-line-right-text {
                    color: red;
                    font-weight: bold;
                    text-align: right;

                    .outer-dialog-center-line-right-text1 {
                        color: #7E888E;
                        font-weight: 400;
                    }
                }

                .outer-dialog-center-line-right-text-box {
                    margin-top: 0.1rem;
                    padding: 0.1rem;
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    color: #78798C;

                    .outer-dialog-center-line-right-text-box-line {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }
            }
        }
    }

    .outer-dialog-footer {
        .outer-dialog-footer-top {
            position: relative;
            display: flex;
            align-items: center;
            font-size: 0.18rem;
            color: #000;
            font-weight: bold;
            margin-bottom: 0.12rem;

            .outer-dialog-footer-yuan {
                position: absolute;
                left: -0.4rem;
                height: 0.28rem;
                width: 0.28rem;
                border-radius: 50%;
                background-color: #D5562E;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.2rem;
                font-weight: 400;
            }
        }

        .outer-dialog-footer-center {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.05rem;

            .outer-dialog-footer-center-box {
                cursor: pointer;
                border-radius: 0.1rem;
                width: 0.8rem;
                text-align: center;
                padding: 0.05rem 0;
                border: 1px solid #F5F5F5;
            }
        }

    }
}

.inner-dialog {
    padding: 0 0.1rem;

    .inner-dialog-top {
        color: #000;
        margin-bottom: 0.1rem;
        font-size: 0.16rem;
        font-weight: bold;

        span {
            color: red;
            font-weight: bold;
        }
    }

    .inner-dialog-tip {
        p {
            padding-left: 0.12rem;
            line-height: 0.3rem;
            color: #000;
            font-weight: bold;
        }

    }

}

.merchantResponse {
    margin-top: 0.2rem;
    color: #000;
    font-weight: bold;

    p {
        color: red;
        font-size: 0.2rem;
        font-weight: bold;
    }

}
</style>